<template>
  <div class="emoji_com" @click.stop>
    <swiper
      v-model="pageIndex"
      :min-moving-distance="120"
      @on-index-change="onIndexChange"
      :show-dots="true"
      dots-position="center"
    >
      <swiper-item
        class="emoji_list"
        v-for="(item, index) in emojiList"
        :key="index"
      >
        <div
          v-for="(item, index) in emojiList[index]"
          :key="index"
          @click="sendEmoji(item.key)"
          class="emojiBox"
        >
          <span class="emoji_pic">{{ item.emoji }}</span>
        </div>
        <img
          @click="deleteEmoji"
          class="delete_emoji"
          src="//cdn.yxvzb.com/WEB/wx-master/images/%E5%88%A0%E9%99%A4@2x.png"
          alt=""
        />
      </swiper-item>
    </swiper>
  </div>
</template>
<script>
// TODO: vux
import { Swiper, SwiperItem } from 'vux';
export default {
  name: 'emoji',
  data() {
    return {
      pageIndex: 0,
      emojiList: []
    };
  },
  methods: {
    onIndexChange(index) {
      this.pageIndex = index;
    },
    // 发送表情
    sendEmoji(data) {
      this.$emit('sendFatherEmoji', data);
    },
    // 删除表情
    deleteEmoji() {
      this.$emit('deleteFatherEmoji', 0);
    }
  },
  components: {
    Swiper,
    SwiperItem
  },
  created() {
    let emoji = this.$emoji.search('').slice(859, 928);
    // console.log(emoji)
    let num = 23; //每个子数组里的元素个数
    let Arr = new Array(Math.ceil(emoji.length / num));
    for (let i = 0; i < Arr.length; i++) {
      Arr[i] = new Array();
      for (let j = 0; j < num; j++) {
        Arr[i][j] = '';
      }
    }
    for (let i = 0; i < emoji.length; i++) {
      Arr[parseInt(i / num)][i % num] = emoji[i];
    }
    this.emojiList = Arr;
    // console.log(this.emojiList);
  }
};
</script>
<style lang="less" scoped>
.emoji_com {
  width: 100%;
  height: 4.44rem;
  background: #f9f9f9;
  .emoji_list {
    padding: 0.37rem 0rem 0.37rem 0;
    display: flex;
    flex-wrap: wrap;
    .emojiBox {
      width: 0.7rem;
      height: 1.16rem;
      margin-right: 0.36rem;
    }
    .emoji_pic {
      // margin-right: 0.25rem;
      font-size: 0.6rem;
    }
  }
  .delete_emoji {
    margin-left: 0.1rem;
    margin-top: 0.3rem;
    width: 0.61rem;
    height: 0.5rem;
  }
}
</style>
<style lang="less">
.vux-slider > .vux-indicator {
  position: absolute !important;
  bottom: -0.1rem !important;
  left: 0rem !important;
  display: flex !important;
  justify-content: center !important;
}
.vux-slider > .vux-indicator > a > .vux-icon-dot,
.vux-slider .vux-indicator-right > a > .vux-icon-dot {
  width: 0.16rem !important;
  height: 0.16rem !important;
  background: #fff;
  border: 1px solid #979797 !important;
}
</style>
